import Checkbox from '@components/Checkbox';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import HTMLText from '@features/PageBuilder/components/HTMLText';

const NewsletterCheckbox = ({ control, className, rules, ...props }) => {
  const {
    options: { consentTextCheckout: consentFromOptions },
  } = useSelector((state) => state.wordpress);
  return (
    <Controller
      name="marketingConsent"
      control={control}
      rules={rules}
      // defaultValue={informations.newsletter}
      render={({ field, fieldState }) => (
        <Checkbox
          {...props}
          {...field}
          className={className}
          error={fieldState.error}
          // onClick={inputChange}
        >
          <HTMLText>{consentFromOptions}</HTMLText>
        </Checkbox>
      )}
    />
  );
};

export default NewsletterCheckbox;
